/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutRegistrationController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'Registration';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.IsValid = true;
            $scope.Control.Form = {};

            $scope.StrengthCheck = $element.data('pwdcheck');
            $scope.StrengthRequiredLevel = $element.data('pwdstrength');
            $scope.StrengthLevel = 0;
            $scope.StrengthText = '';

            $scope.Control.AccountUrl = $element.data('accounturl');

            var validators = [];
            var initiallyValidated = false;


            function getPasswordStrength(pass) {
                var score = 0;
                if (!pass)
                    return score;

                var letters = {};
                for (var i = 0; i < pass.length; i++) {
                    letters[i] = (letters[i] || 0) + 1;
                    var dd = 5 / letters[i];

                    if (dd.toString() == 'NaN')
                        dd = 0;

                    score += dd;
                }

                var variations = {
                    digits: /\d/.test(pass),
                    lower: /[a-z]/.test(pass),
                    upper: /[A-Z]/.test(pass),
                    nonWords: /\W/.test(pass),
                }

                var variationCount = 0;
                for (var check in variations) {
                    variationCount += (variations[check] == true) ? 1 : 0;
                }
                score += (variationCount - 1) * 10;

                if (score.toString() == 'NaN')
                    score = 0;

                return parseInt(score);
            }

            var level = {
                level0: 'very weak',
                level1: 'very weak',
                level2: 'weak',
                level3: 'normal',
                level4: 'strong',
                level5: 'very strong'
            }

            var getLevel = function (bits) {
            
                var matched = 0;

                if (bits < 28) {
                    matched = 1;
                }
                else if (bits >= 28 && bits < 43) {
                    matched = 2;
                }
                else if (bits >= 43 && bits < 68) {
                    matched = 3;
                }
                else if (bits >= 68 && bits < 108) {
                    matched = 4;
                }
                else if (bits >= 108) {
                    matched = 5;
                }

                return matched;
            }

            $scope.Control.validateField = function (name) {
                if (initiallyValidated) {
                    _.first(_.filter(validators, function (x) { return x.name == name })).fn();
                }
            };

            $scope.Control.checkIfEmailExists = function () {
                if ($scope.Order.Current.Profile.Email) {
                    var url = document.location.protocol.toLowerCase() + '//' + document.location.host.toLowerCase() + '/Services/api/Account/CheckIfUserEmailExist?email=' + $scope.Order.Current.Profile.Email;

                    $.ajax({
                        type: "GET",
                        url: url,
                        contentType: 'application/json; charset=utf-8',
                        success: function (response) {
                            $scope.Order.Current.CanCreateAccount = !response.data.UserExist;
                            checkoutConfig.canCreateAccount = !response.data.UserExist;
                            $('.x-checkoutorder').get(0).reload();
                        },
                        failure: function (response) {
                        },
                        error: function (response) {
                        },
                    });
                } else {
                    $scope.Order.Current.CanCreateAccount = false;
                    checkoutConfig.canCreateAccount = false;
                    $('.x-checkoutorder').get(0).reload();
                }
            };

            validators.push({
                name: 'Control.Form.Password',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.Password');

                    if ($scope.StrengthCheck && $scope.Control.Form.Password !== undefined && $scope.Control.Form.Password !== '') {
                        if ($scope.StrengthLevel < $scope.StrengthRequiredLevel) {
                            $scope.Control.Form.PasswordError = true;
                            $scope.Control.Form.PasswordStrengthError = true;
                            $scope.Control.IsValid = false;
                        } else {
                            $scope.Control.Form.PasswordError = false;
                            $scope.Control.Form.PasswordStrengthError = false;
                        }
                    } else {
                        $scope.Control.Form.PasswordError = true;
                        $scope.Control.IsValid = false;
                    }
                }
            });

            validators.push({
                name: 'Control.Form.PasswordConfirmation',
                fn: function () {
                    Validation.reset($scope, 'Control.Form.PasswordConfirmation');
                    Validation.isSame($scope, 'Control.Form.PasswordConfirmation', 'Control.Form.Password', {
                        suffix: 'Mismatch'
                    }).then(function (response) {

                    }, function (error) { });
                }
            });

            if ($scope.StrengthCheck) {
                $scope.$watch('Control.Form.Password', function (value) {

                    var bits = getPasswordStrength($scope.Control.Form.Password);
                    var bitsLevel = getLevel(bits);

                    $scope.StrengthLevel = bitsLevel;
                    $scope.StrengthText = level['level' + bitsLevel];
                });
            }
            
            $element.get(0).validate = function (onComplete) {
                $scope.Control.IsValid = true;
                $scope.Control.Form.PasswordStrengthError = false;
                
                if (!$scope.Order.Current.IsLoggedIn && $scope.Order.Current.CanCreateAccount) {

                    if ($scope.StrengthCheck) {
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.Password' })).fn();
                        
                        if ($scope.Control.IsValid)
                            _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PasswordConfirmation' })).fn();
                    } else {
                        _.first(_.filter(validators, function (x) { return x.name == 'Control.Form.PasswordConfirmation' })).fn();
                    }
                }

                if (typeof (onComplete) === 'function') {
                    setTimeout(function () {
                        onComplete($scope.Control.IsValid);
                    }, 200);
                }

                initiallyValidated = true;
            };

            $scope.Control.applyChanges = function () {
                $scope.setControlValue(controlName, {
                    Password: $scope.Control.Form.Password,
                    PasswordConfirmation: $scope.Control.Form.PasswordConfirmation
                });
            };

            $scope.Control.register = function () {

                $element.get(0).validate(function (valid) {
                    if (valid){
                        var contentElements = $element.find('*[data-section="content"]:not(".form-msg")');
                        var resultElement = $element.find('*[data-section="content"].form-msg');
                        var resultErrorElement = $element.find('*[data-section="content"].form-msg .form-msg-error');
                        var resultSuccessElement = $element.find('*[data-section="content"].form-msg .form-msg-success');

                        ControlService.invokeCheckout($scope, $element, 'CheckoutRegister', {
                            "Password": $scope.Control.Form.Password,
                            "PasswordConfirmation": $scope.Control.Form.PasswordConfirmation
                            }).then(function (response) {
                            var result = jQuery.parseJSON(response);

                            if (result.Success) {
                                contentElements.hide();
                                resultErrorElement.hide();
                                resultElement.show();
                                resultSuccessElement.show();
                            } else {
                                contentElements.hide();
                                resultSuccessElement.hide();
                                resultErrorElement.hide();
                                resultElement.show();

                                $element.find('*[data-section="content"].form-msg .form-msg-error[data-validationmsg="' + result.Code + '"]').show();
                            }
                            $scope.Control.Loading = false;
                        }, function (ex) {
                            contentElements.hide();
                            resultSuccessElement.hide();
                            resultElement.show();
                            resultErrorElement.show();
                            $scope.Control.Loading = false;
                        });
                    }

                });
            };

            $element.get(0).focus = function () {
                if (!$scope.Control.IsValid) {
                    $('.x-invalid:first *[ng-model]', $element).focus();
                } else {
                    $('*[ng-model]:first', $element).focus();
                }
            };

            $element.on('click', '.js-password-reveal', function (e) {
                e.preventDefault();

                if ($(this).hasClass('shown')) {
                    $(this).removeClass('shown').siblings('input').prop('type', 'password');
                } else {
                    $(this).addClass('shown').siblings('input').prop('type', 'text');
                }
            });

            ControlService.getCheckoutData("GetRegistrationData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);

                $scope.setControlValue(controlName, {
                    Password: '',
                    PasswordConfirmation: ''
                });

                $scope.Control.checkIfEmailExists();
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });
        });
})();